import type { LoanType } from './types/LoanType';

export const isValidLoanType = (value: unknown): value is LoanType => {
  const loanTypes = [
    'refinance',
    'purchase',
    'leaseBuyout',
    // enforce that the array contains all values of `LoanType`
  ] satisfies ReadonlyArray<LoanType>;

  return loanTypes.includes(value as LoanType);
};
